import { createContext, useContext } from 'react';

import { TBNDropdownContextProps } from "./types";


export const BNDropdownContext = createContext<TBNDropdownContextProps>({});
export const useBNDropdownContext = (): TBNDropdownContextProps => useContext(BNDropdownContext);
